export default "__VITE_ASSET__TspKfj8c__"